export const transformTreeToFlatArrayWithPath = <T extends { id: string; children?: T[] }>(
  tree: T[] | undefined,
  path: string[] = [],
): { item: T; path: string[] }[] => {
  if (!tree) return [];

  const result: { item: T; path: string[] }[] = [];

  const collect = (node: T, currentPath: string[]) => {
    const newItem = { ...node, children: undefined };
    result.push({ item: newItem, path: currentPath });
    if (Array.isArray(node.children)) {
      node.children.forEach((child) => collect(child, [...currentPath, node.id]));
    }
  };

  tree.forEach((node) => collect(node, path));

  return result;
};
